import React from 'react';

const Dot = ({ active }) => (
    <span
        className="glu-dot"
        style={{ background: active ? '#333333' : '#718490' }}

    />
);

const Dots = ({ slides, activeIndex }) => (
    <div className="glu-dots">
        {slides.map((slide, i) => (
            <Dot key={slide} active={activeIndex === i} />
        ))}
    </div>
);

export default Dots;
